import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Memória de scroll por rota (pathname). O scrollport real é #main-scroll
// (overflow-y: auto no MainLayout) — não o window, que não rola com o novo layout.
const posicoes = new Map();

function getScrollEl() {
  return document.getElementById('main-scroll');
}

export function useScrollMemory() {
  const { pathname } = useLocation();

  useEffect(() => {
    const el = getScrollEl();
    if (!el) return;

    const salvar = () => posicoes.set(pathname, el.scrollTop);
    el.addEventListener('scroll', salvar, { passive: true });

    const alvo = posicoes.get(pathname) ?? 0;
    let raf;
    let tentativas = 0;
    const restaurar = () => {
      const maxScroll = el.scrollHeight - el.clientHeight;
      if (alvo <= 0 || maxScroll >= alvo || tentativas > 60) {
        el.scrollTop = alvo;
        return;
      }
      tentativas += 1;
      raf = window.requestAnimationFrame(restaurar);
    };
    raf = window.requestAnimationFrame(restaurar);

    return () => {
      el.removeEventListener('scroll', salvar);
      if (raf) window.cancelAnimationFrame(raf);
    };
  }, [pathname]);
}
